import React from 'react';
import StepIconContainer from '../step-icon-container';
import StepTextContainer from '../step-text-container';

const StepsContainer = () => (
	<div className="lg:w-2/5 md:w-1/2 md:pr-10 md:py-6">
		<div className="flex relative pb-12">
			<StepIconContainer name="account" bgColor="green-400" />
			<StepTextContainer title="ایحاد اشتراک">
				ابتدا اقدام به ایجاد اشتراک نمایید
			</StepTextContainer>
		</div>
		<div className="flex relative pb-12">
			<StepIconContainer name="project" bgColor="green-400" />
			<StepTextContainer title="پروژه">
				پروژه های خودتان ار ایجاد کنید
			</StepTextContainer>
		</div>
		<div className="flex relative pb-12">
			<StepIconContainer name="team" bgColor="green-400" />
			<StepTextContainer title="تیم">
				تیم خودتان را معرفی نمایید
			</StepTextContainer>
		</div>
		<div className="flex relative pb-12">
			<StepIconContainer name="done" bgColor="green-400" />
			<StepTextContainer title="برسی">
				پیگیری هر وظیفه در کمترین زمان ممکن
			</StepTextContainer>
		</div>
		<div className="flex relative">
			<StepIconContainer name="enjoy" bgColor="green-400" />
			<StepTextContainer title="رضایت و موفقیت">
				این ارزوی هر بیزنس منی هست که همه چیز به شکل چابک پیش برود
			</StepTextContainer>
		</div>
	</div>
);

export default StepsContainer;
